import React from 'react';
import PropTypes from 'prop-types';
import notificationTypes from './notificationTypes';
import './styles.scss';

const FormNotificationItem = ({ message, type }) => {
  let notificationClassNames = 'notification';

  if (type === notificationTypes.ERROR) {
    notificationClassNames += ' error';
  } else if (type === notificationTypes.SUCCESS) {
    notificationClassNames += ' success';
  }

  return (
    <If condition={message}>
      <div className={notificationClassNames}>
        {message}
      </div>
    </If>
  );
};

FormNotificationItem.propTypes = {
  message: PropTypes.string,
  type: PropTypes.string,
};

FormNotificationItem.defaultProps = {
  type: notificationTypes.ERROR,
  message: '',
};

export default FormNotificationItem;
